// src/analytics.js

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID; // mets la valeur dans .env.production

export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn("[Analytics] REACT_APP_GA_ID manquant — GA désactivé");
    return;
  }
  if (document.getElementById("ga-script")) return;

  const script = document.createElement("script");
  script.id = "ga-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag(){ window.dataLayer.push(arguments); };

  window.gtag("js", new Date());

  // On garde send_page_view: false, on gère nous-mêmes
  window.gtag("config", GA_MEASUREMENT_ID, { send_page_view: false });
};

// Utilitaire pour extraire l’eventId depuis le path "/:eventId/upload"
const extractEventId = (path) => {
  const m = path.match(/^\/([^/]+)\/upload(?:\/)?$/);
  return m ? m[1] : undefined;
};

// Page views SPA (version “config” GA4 complète)
export const logPageView = (path) => {
  if (!window.gtag || !GA_MEASUREMENT_ID) return;

  const page_location = typeof window !== "undefined" ? window.location.href : undefined;
  const page_title    = typeof document !== "undefined" ? document.title : undefined;
  const event_id      = extractEventId(path);

  // Méthode recommandée : renvoyer "config" avec page_path / page_title / page_location
  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: path,
    page_location,
    page_title,
    // Param custom pour filtrer par event
    ...(event_id ? { event_id } : {})
  });
};

// Events custom (clics, réussite upload, etc.)
export const logEvent = ({ action, category, label, value, event_id }) => {
  if (!window.gtag) return;
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value,
    ...(event_id ? { event_id } : {})
  });
};
